import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { USERS } from '../constants'

const deleteUser = async (id: number) => {
  await fetchAPI({
    path: `/users/${id}`,
    method: 'delete',
  })
}

export const useDeleteUser = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(deleteUser, {
    async onSuccess() {
      await queryClient.refetchQueries([USERS])

      toast({
        description: t('views.admin.users.services.delete_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
